import { Theme } from '@mui/material';

export const inputBaseStyles = (theme: Theme) => ({
  MuiInputBase: {
    styleOverrides: {
      root: {
        height: '36px',
        letterSpacing: '.5px',
        backgroundColor: theme.palette.mode === 'dark' ? '#222' : '#f9f9f9',
        border: `1px solid ${theme.palette.divider}`,
        color: '#FFF',
        '&:hover': {},
        '&.Mui-focused': {},
        '&.Mui-disabled': {
          color: '#FFF',
        },
        '@media (max-width: 600px)': {
          width: '100%',
          height: '34px',
          fontSize: '14px',
          fontWeight: 500,
        },
      },
    },
  },
});
